module.exports = __webpack_public_path__ + "img/plus.208b187.svg";